import {Component, OnInit} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {SupplyAcquisitionTypeEnum} from '../../../enums/supply-acquisition-type.enum';


/*
 * Supply data viewer is like simple data viewer dedicated only for Supplies because of complicated field visibility logic
 */
@Component({
    selector: 'app-supplies-viewer',
    templateUrl: './supplies-viewer.component.html',
    styleUrls: ['./supplies-viewer.component.scss']
})
export class SuppliesViewerComponent extends EditModalSectionBaseComponent implements OnInit {

    // public supplyAcquisitionTypeEnum = SupplyAcquisitionTypeEnum;

    constructor(public editModalService: EditModalService) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public getShoppingModeDescription(): string {


        if (this.isSupplyOrderActive()) {
            if (this.isPrintSmartSupplyAcquisitionType()) {
                switch (SupplyAcquisitionTypeEnum[this.model.project.supplyAcquisitionType]) {
                    case SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT:
                        return 'MPS (Stückzahlbasiert)';
                    case SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE:
                        return 'MPS (Seitenpreisbasiert)';
                }
                return '';

            } else {
                return 'Kaufen';
            }
        } else {
            return 'Kein Verbrauchsmaterial anfragen';
        }

    }

    public isSecondaryDistributorVisible(): boolean {
        return SupplyAcquisitionTypeEnum[this.model.project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.PURCHASE;
    }


    public isPrintSmartSupplyAcquisitionType(): boolean {
        return this.editModalService.isPrintSmartSupplyAcquisitionType();
    }

    public isSupplyOrderActive(): boolean {
        return this.editModalService.isSupplyOrderActive();
    }

    getCurrentSupplyDistributorName(): string {
        const dName = this.editModalService.getCurrentSupplyDistributorName();
        return dName ? dName : '-';
    }

    getCurrentSecondarySupplyDistributorName(): string {
        const dName = this.editModalService.getCurrentSecondarySupplyDistributorName();
        return dName ? dName : '-';
    }

}
